import React from 'react';
import { useAuth } from '../../Context/AuthenticationContext';
import { hasAccess } from '../../Utils/roles';
import NoAccess from './NoAccess';

interface RoleGuardProps {
  roles: string[];
  serviceLabel?: string;
  children: React.ReactNode;
}

export default function RoleGuard({ roles, serviceLabel, children }: RoleGuardProps) {
  const { user } = useAuth();
  if (hasAccess(user?.roles, roles)) return <>{children}</>;
  return <NoAccess serviceLabel={serviceLabel} />;
}
